module.exports = __webpack_public_path__ + "img/TEKTRO.8474f22c.png";